import { computed } from 'vue';
import _uniqBy from 'lodash/unionBy';
import store from '@/store';
import common from '@/common/common';
import {
	getBannerInfoApi,
	getBannersApi,
	getCategoriesApi,
	getCategoryInfoApi,
	getMarketCategoryApi,
	getMarketApi,
	getMarketOrderApi,
	updateMarketApi,
	getMarketCategoryInfoApi,
	getUserCertification,
	getUserReferralApi,
	getInfoReferralApi,
	getWithdrawalApi,
	getChallengeContents,
	getChallengeSessionApi,
	getNotionTermsApi,
	getNotionNoticeApi,
	getNotificationApi,
	getBuildingNameListApi,
} from '@/api/sys/management';

import { getSessionApi } from '@/api/sys/management';

const appLoading = computed(() => {
	return store.getters['app/appLoading'];
});

export default {
	namespaced: true,
	state: {
		buildingNameList: [],
		buildingNameList_totalCnt: 0,
		buildingNameList_searchParams: {
			building_name: '',
			start_day: '',
			end_day: '',
		},
		notification: [],
		notification_totalCnt: 0,
		notification_searchParams: {
			title: '',
			message: '',
			start_day: '',
			end_day: '',
		},
		theNotionNotice: [],
		notionNotice: [],
		notionNotice_totalCnt: 0,
		notionNotice_searchParams: {
			title: '',
			notionId: '',
			start_day: '',
			end_day: '',
		},
		theNotionTerms: [],
		notionTerms: [],
		notionTerms_totalCnt: 0,
		notionTerms_searchParams: {
			title: '',
			notionId: '',
			start_day: '',
			end_day: '',
		},
		moreCount: 10,
		theChallengeSession: [],
		challengeSession: [],
		challengeSession_totalCnt: 0,
		challengeSession_searchParams: {
			title: '',
			start_day: '',
			end_day: '',
		},
		challengeContents: [],
		challengeContents_totalCnt: 0,
		challengeContents_searchParams: {
			season_id: '',
			email: '',
			uid: '',
			nftId: '',
			start_day: '',
			end_day: '',
		},
		withdrawal: [],
		withdrawal_totalCnt: 0,
		withdrawal_searchParams: {
			email: '',
			social: '',
			option: '',
			createdAt: '',
			updatedAt: '',
		},
		infoReferral: [],
		infoReferral_totalCnt: 0,
		userReferral: [],
		userReferral_totalCnt: 0,
		userCertification: [],
		userCertification_totalCnt: 0,
		marketCategory: localStorage.getItem('marketCategory'),
		selectedIdx: 0,
		banners: [],
		theBanner: {},
		banner_totalCnt: 0,
		banner_searchParams: {
			type: 0,
			name: '',
			link: '',
			hide: 0,
			start_day: '',
			end_day: '',
		},
		categories: [],
		marketCategories: [],
		theCategory: {},
		theMarketCategory: {},
		category_totalCnt: 0,
		marketCategory_totalCnt: 0,
		category_searchParams: {
			code: '',
			name: '',
			hide: 0,
			start_day: '',
			end_day: '',
		},

		marketCategory_searchParams: {
			name: '',
			start_day: '',
			end_day: '',
		},

		markets: [], // 이 부분을 추가합니다.
		theMarket: {},
		market_totalCnt: 0, // 이 부분도 추가합니다.
		market_searchParams: {
			categoryName: '',
			name: '',
			title: '',
			price: '',
			size: '',
			start_day: '',
			end_day: '',
		},
		marketOrderLists: [],
		marketOrder_totalCnt: 0,
		marketOrder_searchParams: {
			categoryName: '',
			name: '',
			phone: '',
			roadAddress: '',
			jibunAddress: '',
			productName: '',
			start_day: '',
			end_day: '',
		},
		userCertification_searchParams: {
			username: '',
			impUid: '',
			phoneNumber: '',
			birthday: '',
			withdrawPoint: '',
			start_day: '',
			end_day: '',
		},
		userReferral_searchParams: {
			from: '',
			to: '',
			referral: '',
			point: '',
			start_day: '',
			end_day: '',
		},
		infoReferral_searchParams: {
			name: '',
			email: '',
			referralBalance: '',
			shareCount: '',
			start_day: '',
			end_day: '',
		},
	},
	getters: {
		buildingNameList: (state: Nullable): Array<any> => state.buildingNameList,
		notification: (state: Nullable) => state.notification,
		notification_totalCnt: (state: Nullable) => state.notification_totalCnt,
		notification_searchParams: (state: Nullable) =>
			state.notification_searchParams,
		theNotionNotice: (state: Nullable) => state.theNotionNotice,
		notionNotice: (state: Nullable) => state.notionNotice,
		notionNotice_totalCnt: (state: Nullable) => state.notionNotice_totalCnt,
		notionNotice_searchParams: (state: Nullable) =>
			state.notionNotice_searchParams,
		theNotionTerms: (state: Nullable) => state.theNotionTerms,
		notionTerms: (state: Nullable) => state.notionTerms,
		notionTerms_totalCnt: (state: Nullable) => state.notionTerms_totalCnt,
		notionTerms_searchParams: (state: Nullable) =>
			state.notionTerms_searchParams,
		theChallengeSession: (state: Nullable) => state.theChallengeSession,
		challengeSession: (state: Nullable) => state.challengeSession,
		challengeSession_totalCnt: (state: Nullable) =>
			state.challengeSession_totalCnt,
		challengeSession_searchParams: (state: Nullable) =>
			state.challengeSession_searchParams,
		challengeContents: (state: Nullable) => state.challengeContents,
		challengeContents_totalCnt: (state: Nullable) =>
			state.challengeContents_totalCnt,
		challengeContents_searchParams: (state: Nullable) =>
			state.challengeContents_searchParams,
		withdrawal: (state: Nullable) => state.withdrawal,
		withdrawal_totalCnt: (state: Nullable) => state.withdrawal_totalCnt,
		withdrawal_searchParams: (state: Nullable) => state.withdrawal_searchParams,
		userCertification: (state: Nullable) => state.userCertification,
		userCertification_totalCnt: (state: Nullable): number =>
			state.userCertification_totalCnt,
		userReferral: (state: Nullable) => state.userReferral,
		userReferral_totalCnt: (state: Nullable): number =>
			state.userReferral_totalCnt,
		infoReferral: (state: Nullable) => state.infoReferral,
		infoReferral_totalCnt: (state: Nullable): number =>
			state.infoReferral_totalCnt,
		marketCategory: (state: Nullable): Array<any> => state.marketCategory,
		banners: (state: Nullable): Array<any> => state.banners,
		theBanner: (state: Nullable): Array<any> => state.theBanner,
		banner_totalCnt: (state: Nullable): number => state.banner_totalCnt,
		banner_searchParams: (state: Nullable): Array<any> =>
			state.banner_searchParams,
		categories: (state: Nullable): Array<any> => state.categories,
		marketCategories: (state: Nullable) => state.marketCategories,
		theCategory: (state: Nullable): Array<any> => state.theCategory,
		theMarketCategory: (state: Nullable): Array<any> => state.theMarketCategory,
		category_totalCnt: (state: Nullable): number => state.category_totalCnt,
		marketCategory_totalCnt: (state: Nullable): number =>
			state.marketCategory_totalCnt,
		category_searchParams: (state: Nullable): Array<any> =>
			state.category_searchParams,
		marketCategory_searchParams: (state: Nullable): Array<any> =>
			state.marketCategory_searchParams,
		markets: (state: Nullable): Array<any> => state.markets,
		theMarket: (state: Nullable): Array<any> => state.theMarket,
		market_totalCnt: (state: Nullable): number => state.market_totalCnt, // 추가
		market_searchParams: (state: Nullable): Array<any> =>
			state.market_searchParams,
		marketOrderLists: (state: Nullable): Array<any> => state.marketOrderLists,
		marketOrder_totalCnt: (state: Nullable): number =>
			state.marketOrder_totalCnt, // 추가
		marketOrder_searchParams: (state: Nullable): Array<any> =>
			state.marketOrder_searchParams,
		userCertification_searchParams: (state: Nullable): Array<any> =>
			state.userCertification_searchParams,
		userReferral_searchParams: (state: Nullable): Array<any> =>
			state.userReferral_searchParams,
		infoReferral_searchParams: (state: Nullable): Array<any> =>
			state.infoReferral_searchParams,
	},
	mutations: {
		SET_MORE_COUNT(state: any, payload: any) {
			state.moreCount = payload;
		},

		SET_CATEGORY(state: any, payload: any) {
			state.marketCategory = payload;

			localStorage.setItem('marketCategory', payload);
		},

		setTheMarketByIndex(state: any, index: any) {
			state.theMarket = state.markets[index];
		},
		updateStatus(status: any, data: any) {
			Object.keys(data).forEach(key => {
				status[key] = data[key];
			});
		},
		// Market Categories 추가
		SET_MARKET_CATEGORIES(state: any, categories: any) {
			state.marketCategories = categories;
		},
	},
	actions: {
		//marketCategory
		async marketCategory(state: Nullable, data: any) {
			state.commit('SET_CATEGORY', data);
		},

		async searchBuildingNameList(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _fetchBuildingNameList({
					...payload,
				});

				if (res.status === 200) {
					const { buildingNameList, totalCnt } = res.data;

					state.commit('updateStatue', {
						...state.state,
						buildingNameList: _uniqBy(buildingNameList, 'idx'),
						buildingNameList_totalCnt: totalCnt,
						buildingNameList_searchParams: {
							name: payload.name,
							building_name: payload.building_name,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
					});
				}
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					buildingNameList: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},

		// 배너정보 검색
		async searchBanners(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _fetchBanner({
					...payload,
				});

				if (res.status === 200) {
					const { banners, totalCnt } = res.data;

					state.commit('updateStatus', {
						...state.state,
						banners: _uniqBy(banners, 'idx'),
						theBanner: {},
						banner_totalCnt: totalCnt,
						banner_searchParams: {
							type: payload.type,
							name: payload.name,
							link: payload.link,
							hide: payload.hide,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
					});
				}
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					banners: [],
				});
			} finally {
				state.commit('updateStatus', {
					theBanner: {},
				});
				store.commit('app/UPDATE_LOADING', false);
			}
		},

		// 카테고리정보 검색
		async searchCategories(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _fetchCategories({
					...payload,
				});

				if (res.status === 200) {
					const { categories, totalCnt } = res.data;

					state.commit('updateStatus', {
						...state.state,
						categories: _uniqBy(categories, 'idx'),
						theCategory: {},
						category_totalCnt: totalCnt,
						category_searchParams: {
							code: payload.code,
							name: payload.name,
							hide: payload.hide,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
					});
					store.commit('app/UPDATE_LOADING', false);
				}
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					categories: [],
				});
			} finally {
				state.commit('updateStatus', {
					theCategory: {},
				});
				store.commit('app/UPDATE_LOADING', false);
			}
		},

		//특정 배너 정보 검색

		async findCategory(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _findCategory({
					...payload,
				});

				if (res.status === 200) {
					const { category } = res.data;

					state.commit('updateStatus', {
						...state.state,
						theCategory: category,
					});
				}
				store.commit('app/UPDATE_LOADING', false);
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					theCategory: {},
				});
				store.commit('app/UPDATE_LOADING', false);
			} finally {
				//store.commit("app/UPDATE_LOADING", false);
			}
		},

		updateTheMarket(
			{ commit, state }: { commit: any; state: any },
			idx: number,
		) {
			const index = state.markets.findIndex(
				(market: any) => market.idx === idx,
			);
			if (index !== -1) {
				commit('updateStatus', { theMarket: state.markets[index] });
			} else {
				console.error('Invalid market idx:', idx);
			}
		},

		async searchMarket(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _fetchMarket({ ...payload });

				if (res.status === 200) {
					const { data, totalCnt } = res.data;

					state.commit('updateStatus', {
						...state.state,
						markets: _uniqBy(data, 'idx'),
						market_totalCnt: totalCnt,
						market_searchParams: {
							categoryName: payload.categoryName,
							name: payload.name,
							title: payload.title,
							price: payload.price,
							size: payload.size,
							desc: payload.desc,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
						//theMarket: data[3], //이 데이터 값을 바꿔야 됨
					});
				}
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					markets: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},
		//marketOrderList
		async searchMarketOrder(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _fetchMarketOrder({ ...payload });

				if (res.status === 200) {
					const { data, totalCnt } = res.data;
					state.commit('updateStatus', {
						...state.state,
						marketOrderLists: _uniqBy(data, 'idx'),
						marketOrder_totalCnt: totalCnt,
						marketOrder_searchParams: {
							categoryName: payload.categoryName,
							name: payload.name,
							phone: payload.phone,
							roadAddress: payload.roadAddress,
							jibunAddress: payload.jibunAddress,
							productName: payload.productName,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
						//theMarket: data[3], //이 데이터 값을 바꿔야 됨
					});
				}
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					markets: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},

		//유저 본인인증 정보
		async userCertification(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _findUserCertification({
					...payload,
				});

				if (res.status === 200) {
					const { data, totalCnt } = res.data;

					state.commit('updateStatus', {
						...state.state,
						userCertification: data,
						userCertification_totalCnt: totalCnt,
						userCertification_searchParams: {
							idx: payload.idx,
							username: payload.username,
							impUid: payload.impUid,
							phoneNumber: payload.phoneNumber,
							birthday: payload.birthday,
							withdrawPoint: payload.withdrawPoint,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
						//theMarket: data[3], //이 데이터 값을 바꿔야 됨
					});
				}
				store.commit('app/UPDATE_LOADING', false);
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					markets: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},
		//referral
		async userReferral(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				//payload와 동일한 새 객체를 복사하여 전달한다.
				//이 payload의 변동사항이 원본에 영향을 미치지 않는다.
				const res = await _findUserReferral({
					...payload,
				});
				if (res.status === 200) {
					const { data, totalCnt } = res.data;

					state.commit('updateStatus', {
						...state.state,
						userReferral: data,
						userReferral_totalCnt: totalCnt,
						userReferral_searchParams: {
							from: payload.from,
							to: payload.to,
							referral: payload.referral,
							point: payload.point,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
						//theMarket: data[3], //이 데이터 값을 바꿔야 됨
					});
				}
				store.commit('app/UPDATE_LOADING', false);
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					markets: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},
		//InfoReferral
		async InfoReferral(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				//payload와 동일한 새 객체를 복사하여 전달한다.
				//이 payload의 변동사항이 원본에 영향을 미치지 않는다.
				const res = await _findInfoReferral({
					...payload,
				});

				if (res.status === 200) {
					const { data, totalCnt } = res.data;

					state.commit('updateStatus', {
						...state.state,
						infoReferral: data,
						infoReferral_totalCnt: totalCnt,
						infoReferral_searchParams: {
							name: payload.name,
							email: payload.email,
							referralBalance: payload.referralBalance,
							shareCount: payload.shareCount,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
						//theMarket: data[3], //이 데이터 값을 바꿔야 됨
					});
				}
				store.commit('app/UPDATE_LOADING', false);
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					markets: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},

		//banner
		updateTheBanner(
			{ commit, state }: { commit: any; state: any },
			idx: number,
		) {
			const index = state.banners.findIndex(
				(banner: any) => banner.idx === idx,
			);
			if (index !== -1) {
				const bannerObj = state.banners[index];

				if (bannerObj.hide && bannerObj.hide === 'show') {
					bannerObj.hide = 0;
				} else {
					bannerObj.hide = 1;
				}

				commit('updateStatus', { theBanner: bannerObj });
			} else {
				console.error('Invalid market idx:', idx);
			}
		},

		//Market Category List

		updateTheMarketCategory(
			{ commit, state }: { commit: any; state: any },
			idx: number,
		) {
			const index = state.marketCategories.findIndex(
				(marketCategories: any) => marketCategories.idx === idx,
			);
			if (index !== -1) {
				commit('updateStatus', {
					theMarketCategory: state.marketCategories[index],
				});
			} else {
				console.error('Invalid market idx:', idx);
			}
		},

		async searchMarketCategories(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _fetchMarketCategory({ ...payload });

				if (res.status === 200) {
					const { data, totalCnt } = res.data;

					state.commit('updateStatus', {
						...state.state,
						marketCategories: _uniqBy(data, 'idx'),
						marketCategory_totalCnt: totalCnt,
						marketCategory_searchParams: {
							idx: payload.idx,
							name: payload.name,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
						//theMarket: data[3], //이 데이터 값을 바꿔야 됨
					});
				}
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					marketCategories: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},
		//withdrawal
		async searchWithdrawal(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _findWithdrwal({ ...payload });

				if (res.status === 200) {
					const { data, totalCnt } = res.data.data;

					state.commit('updateStatus', {
						...state.state,
						withdrawal: _uniqBy(data, 'idx'),
						withdrawal_totalCnt: totalCnt,
						withdrawal_searchParams: {
							email: payload.email,
							social: payload.social,
							option: payload.option,
							createdAt: payload.createdAt,
							updatedAt: payload.updatedAt,
						},
					});
				}
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					marketCategories: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},
		//challengeContents
		async searchChallengeContents(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _findChallengeContents({ ...payload });

				if (res.status === 200) {
					const { data, totalCnt } = res.data.data;
					state.commit('updateStatus', {
						...state.state,
						challengeContents: _uniqBy(data, 'idx'),
						challengeContents_totalCnt: totalCnt,
						challengeContents_searchParams: {
							season_id: payload.season_id,
							email: payload.email,
							uid: payload.uid,
							nftId: payload.nftId,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
					});
				}
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					marketCategories: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},
		//challengeSession
		async searchChallengeSession(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _fetchChallengeSession({ ...payload });

				if (res.status === 200) {
					const { data, totalCnt } = res.data.data;
					state.commit('updateStatus', {
						...state.state,
						challengeSession: _uniqBy(data, 'idx'),
						challengeSession_totalCnt: totalCnt,
						challengeSession_searchParams: {
							title: payload.title,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
						//theMarket: data[3], //이 데이터 값을 바꿔야 됨
					});
				}
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					markets: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},

		updateTheChallengeSession(
			{ commit, state }: { commit: any; state: any },
			idx: number,
		) {
			const index = state.challengeSession.findIndex(
				(session: any) => session.idx === idx,
			);
			if (index !== -1) {
				commit('updateStatus', {
					theChallengeSession: state.challengeSession[index],
				});
			} else {
				console.error('Invalid challengeSession idx:', idx);
			}
		},

		//notionTerms
		async searchNotionTerms(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _fetchNotionTerms({ ...payload });

				if (res.status === 200) {
					const { data, totalCnt } = res.data.data;
					state.commit('updateStatus', {
						notionTerms: _uniqBy(data, 'idx'),
						notionTerms_totalCnt: totalCnt,
						notionTerms_searchParams: {
							title: payload.title,
							notionId: payload.notionId,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
					});
				}
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					markets: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},

		//theNotionTerms
		updateTheNotionTerms(
			{ commit, state }: { commit: any; state: any },
			idx: number,
		) {
			const index = state.notionTerms.findIndex(
				(session: any) => session.idx === idx,
			);
			if (index !== -1) {
				commit('updateStatus', {
					theNotionTerms: state.notionTerms[index],
				});
			} else {
				console.error('Invalid notionTerms idx:', idx);
			}
		},

		//notionNotice
		async searchNotionNotice(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _fetchNotionNotice({ ...payload });

				if (res.status === 200) {
					const { data, totalCnt } = res.data.data;
					state.commit('updateStatus', {
						notionNotice: _uniqBy(data, 'idx'),
						notionNotice_totalCnt: totalCnt,
						notionNotice_searchParams: {
							title: payload.title,
							notionId: payload.notionId,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
						//theMarket: data[3], //이 데이터 값을 바꿔야 됨
					});
				}
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					markets: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},

		//theNotionNotice
		updateTheNotionNotice(
			{ commit, state }: { commit: any; state: any },
			idx: number,
		) {
			const index = state.notionNotice.findIndex(
				(session: any) => session.idx === idx,
			);
			if (index !== -1) {
				commit('updateStatus', {
					theNotionNotice: state.notionNotice[index],
				});
			} else {
				console.error('Invalid notionNotice idx:', idx);
			}
		},

		//notification
		async searchNotification(state: Nullable, payload: any) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}
			try {
				const res = await _fetchNotification({ ...payload });
				console.log('Res', res);
				if (res.status === 200) {
					const { data, totalCnt } = res.data.data;

					state.commit('updateStatus', {
						notification: _uniqBy(data, 'idx'),
						notification_totalCnt: totalCnt,
						notification_searchParams: {
							title: payload.title,
							message: payload.message,
							start_day: payload.start_day,
							end_day: payload.end_day,
						},
						//theMarket: data[3], //이 데이터 값을 바꿔야 됨
					});
				}
			} catch (e: any) {
				if (e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				state.commit('updateStatus', {
					markets: [],
				});
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},
	},
};

async function _fetchBanner(payload: any) {
	return await getBannersApi(payload);
}

async function _fetchCategories(payload: any) {
	return await getCategoriesApi(payload);
}
async function _findCategory(payload: any) {
	return await getCategoryInfoApi(payload);
}

async function _fetchMarket(payload: any) {
	return await getMarketApi(payload);
}

async function _fetchMarketOrder(payload: any) {
	return await getMarketOrderApi(payload);
}

async function _fetchMarketCategory(payload: any) {
	return await getMarketCategoryApi(payload);
}

async function _findUserCertification(payload: any) {
	return await getUserCertification(payload);
}

async function _findUserReferral(payload: any) {
	return await getUserReferralApi(payload);
}

async function _findInfoReferral(payload: any) {
	return await getInfoReferralApi(payload);
}

async function _findWithdrwal(payload: any) {
	return await getWithdrawalApi(payload);
}

async function _findChallengeContents(payload: any) {
	return await getChallengeContents(payload);
}

async function _fetchChallengeSession(payload: any) {
	return await getChallengeSessionApi(payload);
}

async function _fetchNotionTerms(payload: any) {
	return await getNotionTermsApi(payload);
}

async function _fetchNotionNotice(payload: any) {
	return await getNotionNoticeApi(payload);
}

async function _fetchNotification(payload: any) {
	return await getNotificationApi(payload);
}

async function _fetchBuildingNameList(payload: any) {
	return await getBuildingNameListApi(payload);
}
